import { useState } from 'react';
import { useNotify, useGetList } from 'react-admin';
import { Card, CardContent, Typography, Stack, Button } from '@mui/material';
import { card, btn, typo } from '../styles/ds';
import { websiteRequest } from './websiteApi';
import ListingSlots from './ListingSlots';

/**
 * Related products of one listing (WD-038). Empty = automatic (other public
 * listings of the same primary category). Chosen listings appear first, in
 * order; a choice that isn't public at read time is skipped and the automatic
 * list fills the rest — up to four, no duplicates.
 */
const WebsiteRelatedProducts = ({ product, readOnly, onSaved }) => {
  const notify = useNotify();
  const { data: listings = [] } = useGetList('website_products', {
    pagination: { page: 1, perPage: 1000 }, sort: { field: 'name_en', order: 'ASC' },
  });
  const [value, setValue] = useState(() => product.related_product_ids);
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const options = listings.filter(l => l.id !== product.id);
  const notPublished = Object.fromEntries(options
    .filter(l => l.publication_state !== 'published')
    .map(l => [l.id, 'לא מפורסם — לא יוצג עד שיפורסם; במקומו יוצג מוצר אוטומטי']));

  const save = async ids => {
    setSaving(true);
    try {
      const updated = await websiteRequest(`/website_products/${product.id}/related`, 'PUT',
        { version: product.version, related_product_ids: ids });
      notify(ids.length ? 'המוצרים הקשורים נשמרו' : 'המוצרים הקשורים חזרו לבחירה אוטומטית', { type: 'success' });
      onSaved(updated);
    } catch (err) { notify(err.message, { type: 'error' }); }
    finally { setSaving(false); }
  };

  return (
    <Card sx={card.section}>
      <CardContent className="crm-card-content" sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography sx={{ ...typo.sectionTitle, mb: 0.5 }}>מוצרים קשורים (WD-038)</Typography>
        <Typography sx={{ ...typo.meta, mb: 2 }}>
          {product.related_product_ids.length
            ? 'בחירה ידנית: המוצרים שנבחרו מוצגים ראשונים, לפי הסדר. מקומות ריקים, או מוצר שאינו מוצג באתר, מושלמים אוטומטית מאותה קטגוריה.'
            : 'כרגע אוטומטי: עד ארבעה מוצרים מפורסמים מאותה קטגוריה ראשית, לפי סדר התצוגה בקטגוריה. אפשר לבחור ידנית.'}
        </Typography>
        <ListingSlots value={value} options={options} disabled={readOnly || saving} warnings={notPublished}
          onChange={v => { setValue(v); setDirty(true); }} />
        {!readOnly && (
          <Stack direction="row" spacing={1.5} mt={2} flexWrap="wrap" useFlexGap>
            <Button variant="contained" disabled={saving || !dirty} sx={btn.primary}
              onClick={() => save(value.filter(Boolean))}>שמירת מוצרים קשורים</Button>
            {product.related_product_ids.length > 0 && (
              <Button variant="outlined" disabled={saving} sx={btn.cancel} onClick={() => save([])}>חזרה לבחירה אוטומטית</Button>
            )}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};
export default WebsiteRelatedProducts;
